import { render, staticRenderFns } from "./rename-report.vue?vue&type=template&id=60c91228"
import script from "./rename-report.vue?vue&type=script&lang=js"
export * from "./rename-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports